import { render, staticRenderFns } from "./AccessesCard.vue?vue&type=template&id=398d4ba8"
import script from "./AccessesCard.vue?vue&type=script&lang=js"
export * from "./AccessesCard.vue?vue&type=script&lang=js"
import style0 from "./AccessesCard.vue?vue&type=style&index=0&id=398d4ba8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports